type Storable = string | number | boolean | object | null | undefined

export const setLocalStorageItem = (key: string, value: Storable) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error(`Error setting localStorage key “${key}”:`, error)
    }
  }
}

export const removeLocalStorageItem = (key: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.removeItem(key)
    } catch (error) {
      console.error(`Error removing localStorage key “${key}”:`, error)
    }
  }
}

export const getLocalStorageItem = (key: string): Storable | undefined => {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : undefined
    } catch (error) {
      console.error(`Error getting localStorage key “${key}”:`, error)
      return undefined
    }
  }

  return undefined
}

interface MoveLocalStorageItemParams {
  from: string
  to: string
}

export const moveLocalStorageItem = ({ from, to }: MoveLocalStorageItemParams) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      const value = window.localStorage.getItem(from)
      if (value === null) return

      if (window.localStorage.getItem(to) === null) {
        window.localStorage.setItem(to, value)
      }

      window.localStorage.removeItem(from)
    } catch (error) {
      console.error(`Error moving localStorage key “${from}” to “${to}”:`, error)
    }
  }
}
